import { Tealium } from '../Tealium/TealiumTypes';

export enum CategoryType {
  Analytics = 1,
  Affiliates = 2,
  DisplayAd = 3,
  Search = 4,
  Email = 5,
  Personalization = 6,
  Social = 7,
  BigData = 8,
  Misc = 9,
  CookieMatch = 10,
  CDP = 11,
  Mobile = 12,
  Engagement = 13,
  Monitoring = 14,
  CRM = 15,
}

export type Categories = { [name: string]: Tealium.Compliance.State };


